var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.roi['xirr'] > 0)?_c('p',{staticClass:"text-h5"},[_vm._v(_vm._s((_vm.roi['xirr'] * 100).toFixed(2))+"% "),_c('span',{staticClass:"text-small"},[_vm._v("per annum")])]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }